export default class BackLogisticsList {
    userName: string;
    warehouseName: string;
    shipment: string;
    creationTime: Date;
    storeName: string;
}